import { render } from "./DeviceVersionsTab.vue?vue&type=template&id=2c500f1d"
import script from "./DeviceVersionsTab.vue?vue&type=script&lang=js"
export * from "./DeviceVersionsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__